var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormLabel',_vm._b({staticClass:"pt-2"},'FormLabel',{
      label: 'Part Of Term Filters',
      disabled: !_vm.editable,
      description: 'Use custom filters to restrict the types of sections to which a part of term can be assigned.',
      status: _vm.status
    },false)),_c('DynamicFilters',{attrs:{"value":_vm.value,"fields":_vm.config.filterFields || [],"view":_vm.config.view,"disabled":!_vm.editable},on:{"input":function($event){return _vm.update($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }